"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
function Emoji(props) {
    const { label, symbol } = props, rest = __rest(props, ["label", "symbol"]);
    return (React.createElement("span", Object.assign({ "aria-hidden": label ? undefined : true, "aria-label": label ? label : undefined, role: "img" }, rest), symbol));
}
;
exports.default = Emoji;
//# sourceMappingURL=Emoji.js.map